import "core-js/modules/es6.number.constructor.js";
import "core-js/modules/es6.array.slice.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import ApprovalEvent from 'src/store/models/ApprovalEvent';
import { APPROVAL_EVENT_TYPES as _APPROVAL_EVENT_TYPES, APPROVAL_REQUEST_STATUSES as _APPROVAL_REQUEST_STATUSES } from 'src/boot/constants';
export default {
  props: {
    approvalRequestId: {
      type: Number,
      required: true
    },
    minified: {
      type: Boolean,
      default: false
    },
    limit: {
      type: Number,
      default: 0 // 0 means no limit

    },
    approvalStatus: {
      type: String,
      default: ''
    }
  },
  computed: {
    APPROVAL_EVENT_TYPES: function APPROVAL_EVENT_TYPES() {
      return _APPROVAL_EVENT_TYPES;
    },
    APPROVAL_REQUEST_STATUSES: function APPROVAL_REQUEST_STATUSES() {
      return _APPROVAL_REQUEST_STATUSES;
    },
    filteredApprovalEvents: function filteredApprovalEvents() {
      if (!this.limit) return this.approvalEvents;
      return this.approvalEvents.slice(0, this.limit);
    },
    approvalEvents: function approvalEvents() {
      return ApprovalEvent.query().where('approval_request_id', this.approvalRequestId).orderBy('created_at', 'desc').get();
    },
    showMore: function showMore() {
      if (!this.limit) return false;
      return this.approvalEvents.length > this.limit;
    }
  },
  methods: {
    loadApprovalEvents: function loadApprovalEvents() {
      return ApprovalEvent.api().fetch({
        params: {
          approval_request_id: this.approvalRequestId
        }
      });
    }
  },
  mounted: function mounted() {
    this.loadApprovalEvents();
  }
};